import {CoBorrowerController} from "./component/coborrower/coborrowerComponent";
import {CustomerProfileController} from "./route/CustomerProfileController";
import './component/coborrower/co_borrowers_tab.scss';
import {CustomerProfileBorrowerDetailsController} from "./component/details/customerProfileBorrowerDetailsController";
import {CustomerProfileLoanInfoController} from "./component/loan-info/borrower-loan-info.component";
import {InnerCustomerProfileLoanInfoController} from "./component/inner-loan-info/inner-borrower-loan-info.component";
import {CUSTOMER_FINANCIAL_INFO_CONTROLLER} from "./component/financials/customerFinancialInfoController";
import {BorrowerMarketingInfoComponent} from "./component/marketing/borrower-marketing-info.component";
import {APPLICATION_INFO_CONTROLLER} from "./component/application_info/applicationInfoController";
import {CUSTOMER_PROPERTY_INFO} from "./component/proprerty/customerPropertyInfo";
import {CustomerOpportunities} from "./component/opportunities/CustomerOpportunities";
import {EditableFieldComponent} from './component/editable-field/editable-field.component';
import CustomerProfileModuleConfiguration from "./CustomerProfileModuleConfiguration";
import {TextEditableField} from "./component/editable-field/text-editable-field/text-editable-field";
import {CurrencyEditableField} from "./component/editable-field/currency-editable-field/currency-editable-field";
import {EnumEditableFieldComponent} from "./component/editable-field/enum-editable-field/enum-editable-field.component";
import {
    BooleanEditableFieldComponent
} from "./component/editable-field/boolean-editable-field/boolean-editable-field.component";
import {DateEditableField} from "./component/editable-field/date-editable-field/date-editable-field.component";
import {
    NumberEditableFieldComponent
} from "./component/editable-field/number-editable-field/number-editable-field.component";
import {PercentageEditableField} from "./component/editable-field/percentage-editable-field/percentage-editable-field";
import {CustomerActivityComponent} from "./component/activity/customer-activity.component";
import {CustomerAddressComponent} from "./component/address/customer-address.component";
import {StateEditableField} from "./component/editable-field/editable-state/state-editable-field.component";
import {CampaignActionLogComponent} from "./component/campaign-action-log/campaign-action-log.component";
import {OpportunityLogComponent} from "./component/opportunity-log/opportunity-log.component";
import {LoanArchiveLogComponent} from "./component/loan-archive-log/loan-archive-log.component";
import {BorrowerDateFields} from "./component/dates/borrower_date_fields";

CustomerProfileModuleConfiguration
    .createNewModule()
    .controller('customerProfileController', CustomerProfileController.instanceConstructor)
    .component('customerOpportunities', CustomerOpportunities.instance)
    .component('opportunityLog', OpportunityLogComponent.instance)
    .component("coborrowers", CoBorrowerController.instance)
    .component('borrowerLoanInfo', CustomerProfileLoanInfoController.instance)
    .component('innerBorrowerLoanInfo', InnerCustomerProfileLoanInfoController.instance)
    .component('borrowerAddress', CustomerAddressComponent.instance)
    .directive('editableField', EditableFieldComponent.directive)
    .component('textEditableField', TextEditableField.instance)
    .component('dateEditableField', DateEditableField.instance)
    .component('stateEditableField', StateEditableField.instance)
    .component('currencyEditableField', CurrencyEditableField.instance)
    .component('booleanEditableField', BooleanEditableFieldComponent.instance)
    .component('enumEditableField', EnumEditableFieldComponent.instance)
    .component('numberEditableField', NumberEditableFieldComponent.instance)
    .component('percentageEditableField', PercentageEditableField.instance)
    .component('borrowerDetails', CustomerProfileBorrowerDetailsController. instance)
    .component('marketingInfo', BorrowerMarketingInfoComponent.instance)
    .component('customerActivity', CustomerActivityComponent.instance)
    .component('customerCampaignLog', CampaignActionLogComponent.instance)
    .component('loanArchiveLog', LoanArchiveLogComponent.instance)
    .component('borrowerDateFields', BorrowerDateFields.instance)
    .component('borrowerFinancialInfo', {
        controller: CUSTOMER_FINANCIAL_INFO_CONTROLLER,
        template: require('./component/financials/borrower_financial_info.html'),
        bindings: {
            "customer": "<"
        }
    })
    .component('applicationInfo', {
        controller: APPLICATION_INFO_CONTROLLER,
        template: require('./component/application_info/applicationInfo.html'),
        bindings: {
            'customer': '<'
        }
    })
    .component('propertyInfo', {
        controller: CUSTOMER_PROPERTY_INFO,
        template: require('./component/proprerty/borrower_property_info.html'),
        bindings: {
            "customer": "<"
        }
    });
